export const scheduleOpenAppointment = () => ({ type: 'SCHEDULE_OPEN_APPOINTMENT' })
export const scheduleMammoAppointment = () => ({ type: 'SCHEDULE_MAMMO_APPOINTMENT' })
export const scheduleDirectMammoAppointment = () => ({ type: 'SCHEDULE_DIRECT_MAMMO_APPOINTMENT' })
export const scheduleUCAppointment = () => ({ type: 'SCHEDULE_UC_APPOINTMENT' })
export const scheduleOpenToDirectAppointment = () => ({ type: 'SCHEDULE_OPEN_TO_DIRECT_APPOINTMENT' })
export const rescheduleAppointment = () => ({ type: 'RESCHEDULE_APPOINTMENT' })
export const reactivationAppointment = () => ({ type: 'SCHEDULE_REACTIVATION_APPOINTMENT' })
